import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export type ObjetivoCodigo = 'A' | 'T' | 'X';

const ETIQUETAS: Record<ObjetivoCodigo, string> = {
  A: 'Aspiración',
  T: 'Transferencia',
  X: 'Aspiración y Transferencia',
};

export function objetivoLabel(codigo: ObjetivoCodigo | null | undefined): string {
  return codigo ? ETIQUETAS[codigo] ?? '' : '';
}

/**
 * El objetivo se persiste como un solo char: A, T o X (ambas), siguiendo el
 * mismo patrón que el objetivo del establecimiento (E / P / X). En el formulario
 * se edita como dos casillas independientes.
 */
export function objetivoDesdeCheckboxes(aspiracion: boolean, transferencia: boolean): ObjetivoCodigo | null {
  if (aspiracion && transferencia) return 'X';
  if (aspiracion) return 'A';
  if (transferencia) return 'T';
  return null;
}

export function objetivoACheckboxes(codigo: ObjetivoCodigo | null | undefined): { aspiracion: boolean; transferencia: boolean } {
  return {
    aspiracion: codigo === 'A' || codigo === 'X',
    transferencia: codigo === 'T' || codigo === 'X',
  };
}

/** Exige que al menos una de las dos casillas de objetivo esté marcada. */
export function alMenosUnObjetivoValidator(): ValidatorFn {
  return (group: AbstractControl): ValidationErrors | null => {
    const aspiracion = group.get('aspiracion')?.value;
    const transferencia = group.get('transferencia')?.value;

    return aspiracion || transferencia ? null : { objetivoRequerido: true };
  };
}
